<template>
  <div class="body-container cp-details view-container">
    <div class="w cp-details-01">
      <div class="w-box-c">
        <div class="cp-title-01">保障权益/金额</div>
        <div class="main-uls">
          <div class="ul-content">
            <ul class="ul-contents active">
              <li
                class="contents-btn"
                v-for="(value,i) in mainDatas"
                :key="i"
                :class="!value.isShow?'':'add-title-class'"
                @click="showDetail(i)"
              >
                <div class="li-title clearfix">
                  <div class="clearfix line-class" :class="value.describe == ''?'':'li-title-div'">
                    <span class="li-left">{{value.rightName}}</span>
                    <span class="li-right lz-col-ff6e06">{{value.rightValue}}</span>
                  </div>
                  <p class="lz-fs-26 lz-col-666 content-des">{{value.describe}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from "@/components/commons/loading";
//当前实例组件
var vm = null;
export default {
  data: () => ({
    mainDatas: [], //主数据
  }),
  components: {
    "app-loading": loading
  },

  mounted() {
    // vm.getDatas();
    // vm.getAddpolicydata();
    let pid = this.$route.params.id;
    let insuresCardNo = this.$route.params.insuresCardNo;
    let policy = this.$route.params.policy;
    let isPlat = this.$route.params.isPlat;
    this.getDetail(pid,insuresCardNo);
  },

  created() {
    vm = this;
  },
  methods: {
    getDetail(pid,insuresCardNo){
      this.$http({
        url: "/policy/wtPolicys/api/detail",
        contentType: "from",
        data: {
          pid:pid
        }
      })
      .then(res => {
        console.log(res.data.policyRightDto.insureRights)
        if(res.data.policyRightDto&&res.data.policyRightDto.insureRights&&res.data.policyRightDto.insureRights.length>0){
          let tmpArr = res.data.policyRightDto.insureRights;
          tmpArr.map(item=>{
            if(item.insuresCardNo==insuresCardNo){
              this.mainDatas = item.rightList;
            }
          })
        }
      })
      .catch(err => {});
    },
    showDetail(i) {
      if (!this.mainDatas[i].describe) return;
      var item = this.mainDatas[i];
      item.isShow = !item.isShow;
      this.$set(this.mainDatas, i, item);
      console.log(this.mainDatas);
    }
  }
};
</script>
<style lang="scss" scope>
.lz-col-ff6e06 {
  color: #0084ff;
}
.cp-details-01 {
  background-color: #fff;
  padding-top: r(30);
  padding-bottom: r(30);
  margin-bottom: r(15);
}
.cp-title-01 {
  font-size: r(36);
}
.main-uls {
  margin-top: 10px;
  .titles {
    width: 100%;
    @include remCalc(min-height, 90);
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    justify-content: space-around;
    overflow: hidden;
    li {
      -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
      -moz-box-flex: 1;
      -webkit-flex: 0 1 49%; /* Chrome */
      -ms-flex: 0 1 49%; /* IE 10 */
      flex: 0 1 49%; /* NEW, Spec - Opera 12.1, Firefox 20+ */
      min-width: 30%;
      @include remCalc(height, 70);
      text-align: center;
      @include remCalc(line-height, 65);
      @include remCalc(font-size, 30);
      border-radius: 30px;
      margin: 0 5px 10px;
      background-color: #f0f0f0;
      padding: 0 10px;
    }
    li.active {
      background-color: $cpBaseCol;
      color: #fff;
      position: relative;
      border-left: 1px solid #ff6e06;
      border-top: 1px solid #ff6e06;
      border-right: 1px solid #ff6e06 !important;
    }
  }
  .titles-fault {
    width: 100%;
    @include remCalc(min-height, 90);
    overflow: hidden;
    li {
      float: left;
      min-width: 30%;
      @include remCalc(height, 70);
      text-align: center;
      @include remCalc(line-height, 65);
      @include remCalc(font-size, 30);
      border-radius: 30px;
      margin: 0 5px 10px;
      background-color: #f0f0f0;
      padding: 0 10px;
    }
    li.active {
      background-color: $cpBaseCol;
      color: #fff;
      position: relative;
      border-left: 1px solid #ff6e06;
      border-top: 1px solid #ff6e06;
      border-right: 1px solid #ff6e06 !important;
    }
  }
  .fl1 {
    float: left;
    width: 80%;
    vertical-align: middle;
    display: inline-block;

    .fl1_1 {
      font-size: r(32);
      color: #000000;
      line-height: r(100);
    }
    .fl1_11 {
      height: r(60);
      line-height: r(70);
    }
    .fl1_2 {
      font-size: r(26);
      color: #000000;
      height: r(40);
    }
  }

  .frone {
    float: right;
    width: 15%;
    vertical-align: middle;
    display: inline-block;
    line-height: r(100);
    color: #ff6f07;
    font-size: r(32);
    text-align: right;
  }
}
.ul-content {
  margin-top: 0;
}
.ul-contents {
  display: none;
  width: 100%;
  //padding: 0 0 0 r(20);
  border: 1px solid #d8d8d8;
  margin-bottom: 10px;
  .contents-btn:last-of-type {
    padding-bottom: r(20);
    .line-class {
      border: 0;
    }
  }

  .li-title {
    @include remCalc(font-size, 28);
    color: #000;
    line-height: r(50);
    padding: 0 r(20);
    .fr {
      margin-right: r(40);
    }
    .li-title-div {
      padding: 0;
      position: relative;
    }
    .line-class {
      border-bottom: 1px dashed #d8d8d8;
      padding-top: r(25);
      padding-bottom: r(25);
      padding-right: r(50);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .li-left {
        text-align: left;
        flex: 1;
        line-height: 1.5;
      }
      .li-right {
        text-align: right;
        flex: 1;
        line-height: 1.5;
      }
      .len11 {
        line-height: r(50);
        text-align: right;
      }
    }
    .li-title-div:after {
      content: "";
      position: absolute;
      top: r(50);
      right: 0;
      margin-top: r(-22);
      width: r(22);
      height: r(22);
      border-right: 1px solid #b5b5b5;
      border-top: 1px solid #b5b5b5;
      transform: rotate(135deg);
    }

    .content-des {
      color: #000;
      display: none;
      background: #f5f5f5;
      line-height: r(38);
      padding: r(16);
      font-size: r(26);
      position: relative;
    }
    .content-des:before {
      content: "";
      width: 0;
      height: 0;
      border: 5px solid #f5f5f5;
      border-bottom-color: #f5f5f5;
      position: absolute;
      top: -5px;
      right: r(110);
      transform: rotate(45deg);
    }
  }
  .add-newLine-left {
    .line-class {
      height: r(150);
      .fr {
        line-height: r(100);
      }
    }
    .li-title-div:after {
      top: r(78);
    }
  }
  .add-newLine-right {
    .line-class {
      height: r(150);
      .fl {
        line-height: r(100);
      }
    }
    .li-title-div:after {
      top: r(78);
    }
  }
  .add-title-class {
    .li-title-div:after {
      transform: rotate(-45deg);
      margin-top: r(-11);
      top: 50%;
    }
    .content-des {
      display: block;
    }
    .line-class {
      border: 0;
    }
  }
}
.active {
  display: block;
}
</style>